import BusinessInfoRegistration from './BusinessInfoRegistration';

export default BusinessInfoRegistration;